export default __webpack_public_path__ + "static/media/hiVis2.593adc5e.jpg";